import { useMemo } from 'react';
import { isTodaysForm, validateFormData } from '../utils/buildingErrorHandling';

/**
 * useFormValidation - evaluates building forms and returns validation flags
 * @param {Object} buildingData
 * @returns {Object} { areFormsToday, missingForms, isWeatherAcceptable, canProceedToClean }
 */
export const useFormValidation = (buildingData) => {
  return useMemo(() => {
    const missing = [];

    const weatherForm = buildingData?.weatherForm || null;
    const equipmentForm = buildingData?.equipmentForm || null;

    if (!isTodaysForm(weatherForm)) missing.push('Weather');
    if (!isTodaysForm(equipmentForm)) missing.push('Equipment');

    const areFormsToday = missing.length === 0;

    const weatherValidationMessage = validateFormData('Weather Report', weatherForm);
    const isWeatherAcceptable = weatherForm?.weatherCondition === 'Acceptable' && !weatherValidationMessage;

    const canProceedToClean = areFormsToday && isWeatherAcceptable;

    return {
      areFormsToday,
      missingForms: missing,
      isWeatherAcceptable,
      canProceedToClean,
      weatherValidationMessage,
    };
  }, [buildingData]);
};
